import {
  APP_HEADER_HEIGHT,
  APP_HEADER_HEIGHT_MOBILE,
  mediaQuery,
  SCREEN_WIDTH,
} from 'constants/ui';

export const getSidebarStyles = ({ customStyles } = {}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  width: '315px',
  zIndex: 50,

  [`@media(max-width: ${SCREEN_WIDTH.XL - 1}px)`]: {
    width: '240px',
  },

  [mediaQuery.mobile]: {
    width: '100%',
    maxWidth: '320px',
  },

  '&.backdrop': {
    zIndex: 0,
  },

  ...customStyles,
});

export const sidebarDrawerPaperStyles = {
  top: `var(--app-header-height, ${APP_HEADER_HEIGHT}px)`,
  height: `calc(100% - var(--app-header-height, ${APP_HEADER_HEIGHT}px))`,
  // On native the drawer anchors at top:0 (--app-header-height is 0), so its header would sit under
  // the status bar / Dynamic Island. Inset the content by the top safe area. Resolves to 0 off-native.
  paddingTop: 'env(safe-area-inset-top, 0px)',

  [mediaQuery.mobileAndTablet]: {
    top: `var(--app-header-height, ${APP_HEADER_HEIGHT_MOBILE}px)`,
    height: `calc(100% - var(--app-header-height, ${APP_HEADER_HEIGHT_MOBILE}px))`,
  },

  [mediaQuery.mobile]: {
    top: `var(--app-header-height, ${APP_HEADER_HEIGHT_MOBILE}px)`,
    height: `calc(100% - var(--app-header-height, ${APP_HEADER_HEIGHT_MOBILE}px))`,
    maxWidth: '85vw',
  },
};
